import { ref } from 'vue';

/**
 * Belge durum verilerini oluşturur
 * @returns {Object} - Belge state verileri
 */
export const createDocumentState = () => {
  // Tüm belgeler (filterelenmemiş)
  const allDocuments = ref([]);
  
  // Filtrelenmiş belgeler
  const documents = ref([]);
  const isLoadingDocuments = ref(false);
  const documentToDelete = ref(null);
  const isDeleting = ref(false);
  const showDeleteConfirm = ref(false);
  const deleteErrorMessage = ref('');
  const selectedDocumentIds = ref([]);
  
  // Sıralama durumu - Varsayılan olarak yükleme tarihine göre azalan sıralama
  const sortState = ref({
    field: 'addDate',
    direction: 'desc'
  });
  
  // Sıralama tarihçesi - VTable'daki okları düzgün göstermek için kullanılır
  const sortHistory = ref({
    lastColumn: 'addDate',
    columnStates: {
      addDate: 'DESC',
      fileName: null,
      fileType: null,
      state: null
    }
  });

  return {
    allDocuments,
    documents,
    isLoadingDocuments,
    documentToDelete,
    isDeleting,
    showDeleteConfirm,
    deleteErrorMessage,
    selectedDocumentIds,
    sortState,
    sortHistory
  };
};